import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/main/shared/shared.module';
import { ForecastRainfallComponent } from './forecast-rainfall.component';
import { DataService } from './utils/service/data.service';
import { MapService } from './utils/service/map.service';
import { RainfallService } from './utils/service/rainfall.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [ForecastRainfallComponent],
  exports: [ForecastRainfallComponent],
  providers: [DataService, MapService, RainfallService]
})
export class ForecastRainfallModule { }
